import moment from 'moment';
import _ from 'lodash';

import { CreateEditTransferEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_SERVER } from 'Common/Constants';

export const basicURL = '/transfer';
export const getSaveObject = (values, id, IsNewEdit) => {
  let saveObj = {
    SiteId: values[CreateEditTransferEnum.FromSite],
    ToSite: values[CreateEditTransferEnum.ToSite],
    TransactionDT: moment(values[CreateEditTransferEnum.TransferDT]).format(
      DATE_FORMAT_FOR_SERVER
    ),
    Comments: values[CreateEditTransferEnum.Comments],
    ItemDetails: [],
  };
  _.forEach(values[CreateEditTransferEnum.TransferItemsInfo], item => {
    if (item.PriQty || item.SecQty) {
      const obj = {
        TransferQty: item[CreateEditTransferEnum.PriQty],
        QtyPerUnit: item[CreateEditTransferEnum.QtyPerUnit],
        ItemId: item[CreateEditTransferEnum.ItemId],
        ItemCode: item[CreateEditTransferEnum.ItemCode],
        ItemDescription: item[CreateEditTransferEnum.Description],
        Unit: item[CreateEditTransferEnum.Unit],
        SecondaryUnit: item[CreateEditTransferEnum.SecondaryUnit],
        PrimaryQty: item[CreateEditTransferEnum.PriQty],
        SecondaryQty: item[CreateEditTransferEnum.SecQty],
        OnHandQty: item[CreateEditTransferEnum.OnHandQty],
        Packaging: item[CreateEditTransferEnum.Packaging],
      };
      saveObj.ItemDetails.push(obj);
    }
  });
  return saveObj;
};

export const filterDataSource = (
  transferItemsInfo,
  transferItemsData,
  change
) => {
  if (
    transferItemsInfo &&
    transferItemsInfo.length &&
    transferItemsData &&
    transferItemsData.length
  ) {
    const dataSourceCopy = _.cloneDeep(transferItemsData);
    const valueCopy = _.cloneDeep(transferItemsInfo);
    const removeValues = [];
    let index;
    _.each(valueCopy, item => {
      index = _.findIndex(dataSourceCopy, {
        [CreateEditTransferEnum.ItemCode]:
          item[CreateEditTransferEnum.ItemCode],
      });
      if (index === -1) {
        removeValues.push({ ...item });
      }
    });
    removeValues.length && _.pullAllBy(valueCopy, removeValues, 'ItemCode');
    change([CreateEditTransferEnum.transferItemsInfo], valueCopy);
  }
};

export const SiteAllEnum = {
  ALL: 'ALL'
};


// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/helper/index.js